import { render, staticRenderFns } from "./Spring2025.vue?vue&type=template&id=dfbb8234&scoped=true"
import script from "./Spring2025.vue?vue&type=script&lang=js"
export * from "./Spring2025.vue?vue&type=script&lang=js"
import style0 from "./Spring2025.vue?vue&type=style&index=0&id=dfbb8234&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfbb8234",
  null
  
)

export default component.exports